
import { useState } from "react";
import { InvestmentOpportunity } from "@/types/investment";
import BasicInformationFields from "./form-sections/BasicInformationFields";
import FinancialFields from "./form-sections/FinancialFields";
import OriginalContractSection from "./form-sections/OriginalContractSection";
import BalloonPaymentSection from "./form-sections/BalloonPaymentSection";
import PropertyLinksSection from "./form-sections/PropertyLinksSection";
import FormActions from "./form-sections/FormActions";

interface InvestmentFormProps {
  investment: InvestmentOpportunity;
  onSave: (investment: InvestmentOpportunity) => void;
  onCancel: () => void;
}

const InvestmentForm = ({ investment, onSave, onCancel }: InvestmentFormProps) => {
  const [formData, setFormData] = useState<InvestmentOpportunity>(investment);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  const handleInputChange = (field: keyof InvestmentOpportunity, value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleNumericChange = (field: keyof InvestmentOpportunity, value: string) => {
    const numericValue = value === '' ? 0 : parseFloat(value);
    setFormData(prev => ({
      ...prev,
      [field]: numericValue
    }));
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6">
        <BasicInformationFields
          formData={formData}
          onInputChange={handleInputChange}
        />
        <FinancialFields
          formData={formData}
          onInputChange={handleInputChange}
          onNumericChange={handleNumericChange}
        />
      </div>

      <OriginalContractSection
        formData={formData}
        onInputChange={handleInputChange}
        onNumericChange={handleNumericChange}
      />

      <BalloonPaymentSection
        formData={formData}
        onInputChange={handleInputChange}
        onNumericChange={handleNumericChange}
      />

      <PropertyLinksSection
        formData={formData}
        onInputChange={handleInputChange}
      />

      <FormActions
        investment={investment}
        onCancel={onCancel}
      />
    </form>
  );
};

export default InvestmentForm;
